import axios from 'axios';
const StandardsClient = axios.create({
  baseURL: `https://static.diffit.me/standards${window.location.host !== 'app.diffit.me' ? '-dev' : ''}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function getStandardsFromCDN(standardSet, subject, gradeLevel) {
  return await StandardsClient.get(`/${standardSet}/${subject}/${gradeLevel}_final.json`);
}
